/* istanbul ignore next */
const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const normalizeToSave = (base64) => base64?.split("base64,").reverse()[0];

export { toBase64, normalizeToSave };
